import type { Reactive } from 'vue';

export function useStateUpdate<T extends Record<string, any>>(state: Reactive<T>) {
  return function (payload: Partial<T>) {
    for (const k in payload) {
      const key = k;
      const next = payload[key];
      if (!(key in state)) continue;
      if (Object.is(state[key], next)) continue;
      state[key] = next as any;
    }
  };
}
